var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _g, _path17, _path18, _g2, _path19, _path20, _g3, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _line, _path35, _path36, _path37, _path38, _path39, _path40, _rect, _path41, _path42, _path43, _path44, _path45, _path46, _rect2, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _polygon, _line2, _line3, _line4, _line5, _line6, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _polyline, _polyline2, _polyline3, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _polygon2, _path80, _path81, _path82, _path83, _polygon3, _path84, _path85, _line7, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _line8, _path108, _path109, _path110, _rect3, _path111, _path112, _path113, _polygon4, _path114, _path115, _path116, _polygon5, _path117, _polygon6, _polygon7, _polygon8, _path118, _polygon9, _polygon0, _polygon1, _path119;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReading(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    d: "M324.27,107.29l-1.94-5.83,8.81-4.4-10.5.26-.75-3.25,6.29-2.37-7.13-.55-2.33-12.21,6.66-1.38-7.24-1.7s-.51-8.54-.64-9.92a20.5,20.5,0,0,1,0-3.18,24.45,24.45,0,0,1,9.66,0c4.55,1.12,5.23,1.26,5.23,1.26l-.92,5.32,2.77-4.48,7.19,3.53-1.67,6.3,3.95-4.89s6.68,4.79,8.13,6.12,1.74,1.54,1.74,1.54l-7.35,9.06L354,79.71a103.24,103.24,0,0,1,8.25,8.77l-3.14-.35-1.91,6.46,8.75,3.2-9.25-.62-1.27,10.12Z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    d: "M408.6,104.89l.31.66,1.44-8.68,12.81-2L426.3,105l1.55-11.2,3.59-.23,1.42,7.1,1.83-7.48,13.38-.34.3,7.31,3.07-7.39s9.16.94,10.65,1a23.5,23.5,0,0,1,3.37.59,26.43,26.43,0,0,1-1.69,10.27c-2,4.64-2.26,5.34-2.26,5.34L456,108.07l4.28,3.72-5,7-6.39-2.88,4.49,5s-6.25,6.26-7.91,7.57-2,1.58-2,1.58l-8.33-9.39,5.55,11.47a102.07,102.07,0,0,1-14,9c-2.49,1.26-5,2.72-7.1,4.06V111.72a4.36,4.36,0,0,0-4.28-4.43H408.7C408.66,106.61,408.63,105.8,408.6,104.89Z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    d: "M355.38,107.29l1.27-10.12,9.25.62-8.75-3.2,1.91-6.46,8.27.92L360.42,83l5.28-12.49,10.72,2.81-9.08-7.56,1.78-3.32,7.08,2.66-5.63-5.75,7.09-12.07L384.32,51l-4.86-6.8s5.9-7.62,6.82-8.88a23.65,23.65,0,0,1,2.39-2.67,27.71,27.71,0,0,1,8.17,7.18c3,4.33,3.49,5,3.49,5l-4.72,3.82,5.66-1.75,3.48,8.33-6.09,4.09,7-1.2s2.11,9,2.35,11.21.33,2.6.33,2.6l-12.94,2.21,13.25,1.41a106.69,106.69,0,0,1,.25,17.38,107.26,107.26,0,0,0-.16,14.38Z",
    clipRule: "evenodd"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M370.17,324.5H245.87m-51.62,0H91.43a4.3,4.3,0,0,1-4.29-4.29V112.33A4.3,4.3,0,0,1,91.43,108H415.52a4.3,4.3,0,0,1,4.29,4.29V168.1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.75,
    d: "M87.65,232.92l-1,.64-.49-.57,1.48-1.7v1.63Zm0-8.35v-1.06l-.11-.11-4.69,3.31,2.16-6-9-7-5.39,5.14,2.9-7.47-3-2-3,3.54,1.32-4.82-10.15-6-2.47,4L56.8,201l-.26-.11s-7-3-8.14-3.55a18.67,18.67,0,0,0-2.76-.95l-.26-.07-.15.23a22.26,22.26,0,0,0-3,8.3c-.44,4.15-.51,4.74-.51,4.74l-.1.4,3.23.56-3,.64.86,7.78,4.36.37-4,1.39.09.34s2,7.11,2.7,8.74.79,2,.79,2l.14.3,7.6-2.66-6.7,4.7.12.28a85.39,85.39,0,0,0,6.56,12.24l.2.3.95.07-.52-.79a83.23,83.23,0,0,1-6.37-11.84l8.42-5.91-.34-.66-9.5,3.32c-.1-.27-.29-.75-.65-1.6-.58-1.4-2.17-6.89-2.57-8.32l5-1.73-.09-.73-5.5-.47-.72-6.48,4.27-.9v-.74l-4.41-.78c.06-.54.2-1.78.48-4.44a21.1,21.1,0,0,1,2.72-7.74,17.4,17.4,0,0,1,2.36.84c1,.47,6.63,2.89,7.91,3.44l-.73,6.33.7.24,3-4.87,9,5.32-1.62,5.9.65.34,3.69-4.33,2,1.28-3.3,8.47.61.41,6.14-5.86,8,6.28-2.37,6.64.57.43,5.15-3.64Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.75,
    d: "M47.1,199.86c5.58,9.66,12,20.3,18.8,30.58,4.09,6.13,8.33,12.13,12.67,17.71l-1.29-.31c-4.13-5.37-8.17-11.1-12.06-17C58.38,220.62,52,210,46.38,200.27Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.75,
    d: "M83.63,233a39.18,39.18,0,0,0-4.17,6.24,30.28,30.28,0,0,0-2.55,7l-.81-.19a31.3,31.3,0,0,1,2.63-7.2A39.4,39.4,0,0,1,83,232.48Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.75,
    d: "M76.3,220.56a19.54,19.54,0,0,0-5,7.2,41.79,41.79,0,0,0-2.2,7.59l-.81-.17a41.93,41.93,0,0,1,2.25-7.73,20.2,20.2,0,0,1,5.23-7.51Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.75,
    d: "M59.69,245a13.77,13.77,0,0,1,6.09-3.53,15.4,15.4,0,0,1,7.38-.41l-.19.8a14.68,14.68,0,0,0-7,.4,13.16,13.16,0,0,0-5.73,3.31Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.75,
    d: "M53.45,234.19a14.11,14.11,0,0,1,5.69-3.42h0a18.81,18.81,0,0,1,6.37-.62l0,.82a18.15,18.15,0,0,0-6.09.59A13.33,13.33,0,0,0,54,234.79Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.75,
    d: "M49.65,223.74c.8-.87,2.54-1.45,4.5-1.74a18.29,18.29,0,0,1,6.21.11l-.18.81a17.35,17.35,0,0,0-5.92-.1c-1.78.26-3.35.76-4,1.48Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.75,
    d: "M61.62,209a12.44,12.44,0,0,0-2.41,4.16,17.65,17.65,0,0,0-1.14,5.23l-.82,0a18.5,18.5,0,0,1,1.18-5.49A13.45,13.45,0,0,1,61,208.4Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.75,
    d: "M46.08,212.2a41.53,41.53,0,0,1,4.43,0,18.87,18.87,0,0,1,4.16.73l-.23.8a17.28,17.28,0,0,0-4-.7,42.59,42.59,0,0,0-4.35,0Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.75,
    d: "M87.65,267.21l.38-.12v6.18l-.38.11v-6.17Zm0,7.84.38.31V319.2a4.25,4.25,0,0,0,.3,1.56,4.09,4.09,0,0,0,.87,1.33l.33.33-.39.25c-2.29,1.49-4,2.45-4,2.45l-.26.14-5.74-6.41,3.74,7.65-.33.17s-.31.13-1.89,1S72,331.56,72,331.56l-.34.14-1.94-4,.15,4.61L62,334.17l-1.05-3.12-.19,3.42h-.36l-5,.06a23.25,23.25,0,0,1-8.93-2.06l-.27-.12,0-.29a20.73,20.73,0,0,1,.65-2.94c.41-1.24,2.66-8.85,2.66-8.87l.08-.27,5.5,0-4.54-2.09,4.93-11.2,5.2.78-4.07-2.71,1.64-3.37,8.14,2.09-6-5,1.86-3,.71.28-1.58,2.6L68.16,304l-.33.66-9.18-2.37-1.09,2.23,4.95,3.29-.27.69-6.31-1-4.4,10L56.94,320l-.15.72-6.64,0c-.41,1.37-2.24,7.54-2.59,8.62A17,17,0,0,0,47,331.9a22.05,22.05,0,0,0,8.35,1.87l4.67,0,.26-4.67L61,329l1.46,4.32,6.64-1.55L68.91,326l.71-.18L72,330.73c1.41-.59,6.93-2.92,8.29-3.69.83-.47,1.32-.73,1.6-.88l-4.62-9.43.62-.41,7.16,8c.5-.3,1.72-1,3.28-2a4.76,4.76,0,0,1-.73-1.23,5,5,0,0,1-.36-1.85V300.27l.38-.1V275.05Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.75,
    d: "M49.62,330.14c9.3-7,19.51-14.87,29.3-23.21,3-2.53,5.88-5.09,8.73-7.68v1.16q-4,3.63-8.17,7.17c-9.79,8.34-20,16.26-29.35,23.25Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.75,
    d: "M67.43,297.4a20.37,20.37,0,0,0,8.06,4.3A43.28,43.28,0,0,0,83.61,303l-.07.86a43.05,43.05,0,0,1-8.28-1.38A21,21,0,0,1,66.85,298Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.75,
    d: "M84.33,319.34a14.75,14.75,0,0,1-4.23-5.46h0a19.34,19.34,0,0,1-1.43-6.51l.86-.06a18.66,18.66,0,0,0,1.36,6.23,13.86,13.86,0,0,0,4,5.14Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.75,
    d: "M74,324.56c-1-.72-1.82-2.44-2.36-4.43a19.18,19.18,0,0,1-.65-6.45l.86.09a18.09,18.09,0,0,0,.63,6.13c.49,1.82,1.2,3.37,2,4Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.75,
    d: "M57.26,314a12.85,12.85,0,0,0,4.6,2,18,18,0,0,0,5.55.53l0,.86a19.34,19.34,0,0,1-5.81-.55,13.86,13.86,0,0,1-4.92-2.15Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.75,
    d: "M62.5,329.68a44.45,44.45,0,0,1-.58-4.58,19,19,0,0,1,.24-4.4l.85.14a18,18,0,0,0-.23,4.21,43.42,43.42,0,0,0,.57,4.49Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.75,
    d: "M87.65,262.16l-.59-.17.59-5.91v6.08Zm0-11v-.77l-12.08-3-1.88,6.18.08-6.49-7-.54L65,253.32l-2.72-7.26-13.38.48-1,9-3.17-9.23-4.15.54,0,5.77L38,247l-13.67,2.31.89,5.81-3.58-5.38-.26.09s-8.68,2.64-10.1,3a23.57,23.57,0,0,0-3.23,1.24l-.24.12,0,.27a26.47,26.47,0,0,0,3.64,9.77c2.8,4.11,3.21,4.75,3.22,4.75l.2.27,3.55-2.07L16,270.39l6.65,6.3,4.45-3.15-2.68,4.52.3.2s7.26,4.89,9.13,5.85S36,285.2,36,285.2l.34.35,5.16-8.74-2.59,9.81.28.14a100.62,100.62,0,0,0,15.3,6.07,106.49,106.49,0,0,1,14.61,5.53l.24.12,8.19-8.2-4.3,11.2.47.07a35.68,35.68,0,0,0,14-1.38v-.79a35.81,35.81,0,0,1-13.4,1.48l4.6-12-.62-.4-9.07,9.08a105.47,105.47,0,0,0-14.48-5.46,98.16,98.16,0,0,1-14.9-5.89l3.12-11.86-.69-.28-6.1,10.35c-.33-.19-.9-.5-1.87-1-1.62-.82-7.39-4.68-8.76-5.6l3.21-5.43-.54-.5-5.39,3.82-5.71-5.41,3.22-4.13-.48-.56-4.65,2.7c-.3-.46-1.09-1.64-3-4.45a25.43,25.43,0,0,1-3.48-9.17,20.32,20.32,0,0,1,2.83-1.07c1.27-.35,8.38-2.51,9.86-3L25.56,257l.69-.27-1-6.77,12.36-2.09,3.07,6.63.72-.16,0-6.81,2.88-.37,3.52,10.25.74-.08,1.08-10.07,12.18-.44,2.95,7.87.72,0,1.88-7.29,5.67.44-.11,8.42.74.12,2.45-8Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 10,
    d: "M318.25,65.58c8,9.52,16.81,20.25,25,31.33a275,275,0,0,1,21.66,33.35q1.17,2.22,2.27,4.45c.73,1.48,1.41,2.94,2.05,4.36l.84-.37q-1-2.2-2.06-4.4t-2.29-4.47A274.17,274.17,0,0,0,344,96.36C335.81,85.28,327,74.53,319,65Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 10,
    d: "M352,130.46a16.15,16.15,0,0,1,6.6-1.43,17.73,17.73,0,0,1,6.62,1.44l.35-.85a18.71,18.71,0,0,0-7-1.51,16.92,16.92,0,0,0-7,1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 10,
    d: "M339.27,116.51a43.79,43.79,0,0,1,8.13-2,33.57,33.57,0,0,1,8.34,0l.1-.92a35.36,35.36,0,0,0-8.56,0,44.89,44.89,0,0,0-8.3,2.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 10,
    d: "M329,104.1a21.66,21.66,0,0,1,9.47-2.54,46.29,46.29,0,0,1,8.81.55l.13-.92a47.1,47.1,0,0,0-9-.56,22.76,22.76,0,0,0-9.87,2.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 10,
    d: "M361,95.9a15.47,15.47,0,0,0-6,5.07,17.16,17.16,0,0,0-3.22,7.6l.92.11a16.25,16.25,0,0,1,3.05-7.17,14.59,14.59,0,0,1,5.64-4.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 10,
    d: "M351.94,85.24a15.8,15.8,0,0,0-5.75,4.69h0a20.77,20.77,0,0,0-3.06,6.46l.88.27a20.2,20.2,0,0,1,2.92-6.18,15,15,0,0,1,5.42-4.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 10,
    d: "M342.39,77.29c-1.21.51-2.49,2.12-3.53,4.07a20.55,20.55,0,0,0-2.24,6.58l.92.11a19.48,19.48,0,0,1,2.14-6.26c.95-1.78,2.06-3.23,3.07-3.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 10,
    d: "M322.35,84.3a14,14,0,0,1,5.28-1,19.67,19.67,0,0,1,5.93.79l.26-.89a20.7,20.7,0,0,0-6.21-.83A14.87,14.87,0,0,0,322,83.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 10,
    d: "M331.6,69.17c-.7,1.73-1.28,3.19-1.71,4.64a20.87,20.87,0,0,0-.81,4.66l.93.06a19.22,19.22,0,0,1,.77-4.46,45.58,45.58,0,0,1,1.68-4.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 10,
    d: "M367.62,106.94a40.53,40.53,0,0,0-4.6,8.2A26.07,26.07,0,0,0,361,123l.92.07a25.3,25.3,0,0,1,2-7.59,39.37,39.37,0,0,1,4.49-8Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 10,
    d: "M371.83,81.6a2.4,2.4,0,1,0,1.7,2.93A2.39,2.39,0,0,0,371.83,81.6Z"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    d: "M324.27,107.29l-1.94-5.83,8.81-4.4-10.5.26-.75-3.25,6.29-2.37-7.13-.55-2.33-12.21,6.66-1.38-7.24-1.7s-.51-8.54-.64-9.92a20.5,20.5,0,0,1,0-3.18,24.45,24.45,0,0,1,9.66,0c4.55,1.12,5.23,1.26,5.23,1.26l-.92,5.32,2.77-4.48,7.19,3.53-1.67,6.3,3.95-4.89s6.68,4.79,8.13,6.12,1.74,1.54,1.74,1.54l-7.35,9.06L354,79.71a103.24,103.24,0,0,1,8.25,8.77l-3.14-.35-1.91,6.46,8.75,3.2-9.25-.62-1.27,10.12Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    d: "M324.27,107.29l-1.94-5.83,8.81-4.4-10.5.26-.75-3.25,6.29-2.37-7.13-.55-2.33-12.21,6.66-1.38-7.24-1.7s-.51-8.54-.64-9.92a20.5,20.5,0,0,1,0-3.18,24.45,24.45,0,0,1,9.66,0c4.55,1.12,5.23,1.26,5.23,1.26l-.92,5.32,2.77-4.48,7.19,3.53-1.67,6.3,3.95-4.89s6.68,4.79,8.13,6.12,1.74,1.54,1.74,1.54l-7.35,9.06L354,79.71a103.24,103.24,0,0,1,8.25,8.77l-3.14-.35-1.91,6.46,8.75,3.2-9.25-.62-1.27,10.12Z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 10,
    d: "M462,96.76c-11.53,6.88-24.46,14.33-37.67,21.13s-26.63,12.92-39.21,17.18q-2.56.87-5.11,1.64t-5,1.41l.25,1c1.67-.44,3.35-.92,5-1.42s3.4-1.07,5.15-1.66c12.63-4.28,26.12-10.43,39.35-17.24S451,104.51,462.51,97.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 10,
    d: "M387.18,121.24a17.17,17.17,0,0,1,.36,7.26,19,19,0,0,1-2.68,6.78l.85.52a20.18,20.18,0,0,0,2.81-7.13,18.11,18.11,0,0,0-.38-7.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 10,
    d: "M404.21,110.2a46.91,46.91,0,0,1,.73,9,36.33,36.33,0,0,1-1.42,8.87l1,.27a37.82,37.82,0,0,0,1.46-9.11,48.94,48.94,0,0,0-.74-9.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 10,
    d: "M419.19,101.43a23.36,23.36,0,0,1,1.06,10.5,51,51,0,0,1-2.13,9.27l.95.29a50.8,50.8,0,0,0,2.17-9.45,24.4,24.4,0,0,0-1.11-11Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 10,
    d: "M422.32,136.87A16.67,16.67,0,0,0,418,129.6a18.62,18.62,0,0,0-7.52-4.76l-.28,1a17.48,17.48,0,0,1,7.09,4.5,15.67,15.67,0,0,1,4.08,6.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 10,
    d: "M435.23,129.12a17.09,17.09,0,0,0-4-6.92h0a22.53,22.53,0,0,0-6.33-4.38l-.45.89a21.27,21.27,0,0,1,6.06,4.18,16.13,16.13,0,0,1,3.75,6.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 10,
    d: "M445.34,120.37c-.33-1.38-1.82-3-3.71-4.47a22.24,22.24,0,0,0-6.6-3.52l-.28,1a20.92,20.92,0,0,1,6.28,3.35c1.72,1.33,3.07,2.77,3.34,3.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 10,
    d: "M441.39,97.85a15,15,0,0,1,.11,5.78,21.4,21.4,0,0,1-1.87,6.17l.89.43a22,22,0,0,0,2-6.46,16.1,16.1,0,0,0-.13-6.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 10,
    d: "M455.85,110.33a47.37,47.37,0,0,0-4.64-2.63,21.52,21.52,0,0,0-4.8-1.68l-.22,1a21,21,0,0,1,4.59,1.6,50.22,50.22,0,0,1,4.55,2.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 10,
    d: "M409.43,142a43.37,43.37,0,0,0-7.91-6.32,28.15,28.15,0,0,0-8-3.58l-.23,1a27,27,0,0,1,7.71,3.45,42.32,42.32,0,0,1,7.71,6.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 10,
    d: "M435.62,150.89a2.58,2.58,0,1,0-3.41,1.29A2.59,2.59,0,0,0,435.62,150.89Z"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    d: "M408.6,104.89l.31.66,1.44-8.68,12.81-2L426.3,105l1.55-11.2,3.59-.23,1.42,7.1,1.83-7.48,13.38-.34.3,7.31,3.07-7.39s9.16.94,10.65,1a23.5,23.5,0,0,1,3.37.59,26.43,26.43,0,0,1-1.69,10.27c-2,4.64-2.26,5.34-2.26,5.34L456,108.07l4.28,3.72-5,7-6.39-2.88,4.49,5s-6.25,6.26-7.91,7.57-2,1.58-2,1.58l-8.33-9.39,5.55,11.47a102.07,102.07,0,0,1-14,9c-2.49,1.26-5,2.72-7.1,4.06V111.72a4.36,4.36,0,0,0-4.28-4.43H408.7C408.66,106.61,408.63,105.8,408.6,104.89Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    d: "M408.6,104.89l.31.66,1.44-8.68,12.81-2L426.3,105l1.55-11.2,3.59-.23,1.42,7.1,1.83-7.48,13.38-.34.3,7.31,3.07-7.39s9.16.94,10.65,1a23.5,23.5,0,0,1,3.37.59,26.43,26.43,0,0,1-1.69,10.27c-2,4.64-2.26,5.34-2.26,5.34L456,108.07l4.28,3.72-5,7-6.39-2.88,4.49,5s-6.25,6.26-7.91,7.57-2,1.58-2,1.58l-8.33-9.39,5.55,11.47a102.07,102.07,0,0,1-14,9c-2.49,1.26-5,2.72-7.1,4.06V111.72a4.36,4.36,0,0,0-4.28-4.43H408.7C408.66,106.61,408.63,105.8,408.6,104.89Z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 10,
    d: "M388.87,37.07c-.26,14-.8,29.63-2.06,45.11s-3.25,30.79-6.42,44.3q-.64,2.76-1.37,5.46c-.48,1.79-1,3.53-1.51,5.22l1,.3c.54-1.72,1.05-3.48,1.53-5.25s.93-3.61,1.37-5.49c3.18-13.57,5.18-28.95,6.45-44.46s1.8-31.1,2.06-45.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 10,
    d: "M369.25,117a18,18,0,0,1,6.64,3.68,20,20,0,0,1,4.54,6.14l.93-.47a20.9,20.9,0,0,0-4.78-6.44,18.83,18.83,0,0,0-7-3.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 10,
    d: "M368.87,95.79a48.89,48.89,0,0,1,8.38,4.33,38.18,38.18,0,0,1,7.08,6.16l.77-.7a39.2,39.2,0,0,0-7.27-6.33,51,51,0,0,0-8.56-4.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 10,
    d: "M369.36,77.65a24.28,24.28,0,0,1,9.9,4.87,51.36,51.36,0,0,1,7.05,7l.79-.68a53.42,53.42,0,0,0-7.19-7.15,25.47,25.47,0,0,0-10.33-5.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 10,
    d: "M402.55,94.46a17.39,17.39,0,0,0-8.85-.17,19.41,19.41,0,0,0-8.38,4l.7.78a18.32,18.32,0,0,1,7.91-3.81,16.54,16.54,0,0,1,8.32.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 10,
    d: "M402.8,78.72a17.66,17.66,0,0,0-8.34-.29h0a23.4,23.4,0,0,0-7.39,3.19l.54.89a22.86,22.86,0,0,1,7.07-3.07,16.7,16.7,0,0,1,7.86.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 10,
    d: "M400.62,64.91c-1.41-.48-3.68-.06-6,.82a22.82,22.82,0,0,0-6.77,3.91l.69.78A22,22,0,0,1,395,66.7c2.12-.8,4.15-1.2,5.31-.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 10,
    d: "M378.45,56a16,16,0,0,1,5.19,3.1,22.57,22.57,0,0,1,4.44,5.07l.88-.55a23.14,23.14,0,0,0-4.65-5.31,16.74,16.74,0,0,0-5.58-3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 10,
    d: "M397.51,50a51.17,51.17,0,0,0-4.89,2.66A22.47,22.47,0,0,0,388.48,56l.74.73a21.81,21.81,0,0,1,4-3.2A51.41,51.41,0,0,1,398,51Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 10,
    d: "M400,108.74a45.3,45.3,0,0,0-10,3.52,29.22,29.22,0,0,0-7.6,5.13l.73.74a28.28,28.28,0,0,1,7.33-4.93,44,44,0,0,1,9.73-3.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 10,
    d: "M422.34,90.4a2.69,2.69,0,1,0-.73,3.74A2.7,2.7,0,0,0,422.34,90.4Z"
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    d: "M355.38,107.29l1.27-10.12,9.25.62-8.75-3.2,1.91-6.46,8.27.92L360.42,83l5.28-12.49,10.72,2.81-9.08-7.56,1.78-3.32,7.08,2.66-5.63-5.75,7.09-12.07L384.32,51l-4.86-6.8s5.9-7.62,6.82-8.88a23.65,23.65,0,0,1,2.39-2.67,27.71,27.71,0,0,1,8.17,7.18c3,4.33,3.49,5,3.49,5l-4.72,3.82,5.66-1.75,3.48,8.33-6.09,4.09,7-1.2s2.11,9,2.35,11.21.33,2.6.33,2.6l-12.94,2.21,13.25,1.41a106.69,106.69,0,0,1,.25,17.38,107.26,107.26,0,0,0-.16,14.38Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    d: "M355.38,107.29l1.27-10.12,9.25.62-8.75-3.2,1.91-6.46,8.27.92L360.42,83l5.28-12.49,10.72,2.81-9.08-7.56,1.78-3.32,7.08,2.66-5.63-5.75,7.09-12.07L384.32,51l-4.86-6.8s5.9-7.62,6.82-8.88a23.65,23.65,0,0,1,2.39-2.67,27.71,27.71,0,0,1,8.17,7.18c3,4.33,3.49,5,3.49,5l-4.72,3.82,5.66-1.75,3.48,8.33-6.09,4.09,7-1.2s2.11,9,2.35,11.21.33,2.6.33,2.6l-12.94,2.21,13.25,1.41a106.69,106.69,0,0,1,.25,17.38,107.26,107.26,0,0,0-.16,14.38Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M417.39,241.17V236a14.67,14.67,0,0,0,4.54,1.1v5l-4.52-.9Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M107.25,114.77a3.32,3.32,0,1,1-3.32,3.32A3.32,3.32,0,0,1,107.25,114.77Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M130.47,114.77a3.32,3.32,0,1,1-3.32,3.32A3.32,3.32,0,0,1,130.47,114.77Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M153.7,114.77a3.32,3.32,0,1,1-3.32,3.32A3.32,3.32,0,0,1,153.7,114.77Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M176.92,114.77a3.32,3.32,0,1,1-3.32,3.32A3.32,3.32,0,0,1,176.92,114.77Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M188,447.6h16.51a10.49,10.49,0,0,0-1.59,2.15l14.51.3A8.86,8.86,0,0,0,216,447.6h10.28a11,11,0,0,0-1.59,2.15l14.51.3a9,9,0,0,0-1.42-2.45h30.08a4.24,4.24,0,0,1,4.23,4.23v11.26a4.25,4.25,0,0,1-4.23,4.24H188a4.26,4.26,0,0,1-4.24-4.24V451.83A4.25,4.25,0,0,1,188,447.6Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M188,447.6h16.51a10.49,10.49,0,0,0-1.59,2.15l14.51.3A8.86,8.86,0,0,0,216,447.6h10.28a11,11,0,0,0-1.59,2.15l14.51.3a9,9,0,0,0-1.42-2.45h30.08a4.24,4.24,0,0,1,4.23,4.23v7.55a3.27,3.27,0,0,1-1.44.32H185.2a3.34,3.34,0,0,1-1.44-.32v-7.55A4.25,4.25,0,0,1,188,447.6Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M159.24,214.6l.3,3.58v-.9l.3,1.79.3.9.3.6.3.59.59.3.3.9.6.3.3.89.59.3.3.6h.6l.3.59h.59l.6.3.3.6h.6l.59.3,1.49.29h1.79l1.2-.29.6-.3.59-.3.3-.3.6-.6.3-.29.59-.6v-.3l.6-.6h.3l.3,3,.29.3.3,1.49.6.3.3.59.3.3h2.09l1.19-.59.3-.6.3-.9v-1.49l-.3-.89-.3-2.39-.3-1.2-.3-1.19-.3-3-.29-1.5-.3-1.49-.3-1.79-.3-2.68-.3-.9-.3-.6-.59-.59-.6-.6-.6-.3-.3-.3-.89-.29-1.19-.3-.6-.3-1.19-.3H168.2l-.9.3-.6.3-.59.3-.6.29-.6.3-.59.6-.6.3-.6.59-.3.3-.59.6-.3.6-.3.29-.6.6-.29.3-.3.6-.3.3-.3.89-.3,1.19-.3,1.2Zm10.45,6.26h-.9l-.59-.29-.6-.3-.6-.3-.3-.6-.59-.3-.3-.59-.3-.6-.6-.89v-.6l.3-2.39h0l.3-.3.3-.59.6-.6.29-.3.6-.6.3-.29.89-.6.6-.3h2.69l.59.3.6.3-.6,3,.3-.6-.59,1.79-.3,1.2-.3.89-.3.9-.3.89-.3.6-.3.3-.59.89Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M125,220.63l.44,4.36v-1.31l.44,1.74h.44v.44h.43l.44.88h2.62l1.3-.44.88-.44.44-.87.43-1.31.44-3.05.43-3.94,3.5-.44,4.37-.43,3.93-.44H146l.44,2.19.43.87.44,1.31.44,1.75.44,2.62.43,1.3.44,1.76.87.43.44.87.44.44h3.05l1.75-.87.43-.87.44-1.32v-2.62l-.44-2.18-.43-1.31-.44-1.74-.43-1.76-.44-.87-.44-.87-.44-2.18-.43-.87-.44-.88-.43-.87-.44-.87-.44-1.32-.43-.87-.44-.87-.44-.87-.44-.88-.87-1.31-.43-.87-.44-.44-.44-.87-.87-.87-.44-.88-.87-.87-.43-.88-.88-.87-.44-.87-.87-.44L142,194l-.87-.44-.88-.87-.87-.44-1.31-.44H136.8l-1.3.44-.88.44-.88.87-.87.44L132,195.3l-.44.87-.44.44-.43.87-.44,1.31-.43.88-.44.87-.43,1.31-.44,2.18-.44,1.31-.44,1.31L127.2,208l-.44,1.31-.43,3.06-.44,2.62-.44,2.18-.44,3.5ZM137.68,208h-1.75l.44-2.18.43-.87.44-2.19h0l.44-.87.87.44.44,1.3.87.44.43,1.31.88.44.44,1.3V208Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M265.5,171.91a.76.76,0,0,1-.76-.76.75.75,0,0,1,.76-.75h69.93a.75.75,0,0,1,.76.75.76.76,0,0,1-.76.76Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M120.64,236.06a.76.76,0,0,1,0-1.52H186.8a.76.76,0,1,1,0,1.52Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M120.64,241a.76.76,0,0,1,0-1.51H186.8a.76.76,0,1,1,0,1.51Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 257.17,
    x2: 325.62,
    y1: 177.29,
    y2: 177.29,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M129.34,329.21h53.52a2,2,0,0,1,2,2v25.41h0v9.73c0,.5-.09,1-.75.39L174,358.47H129.34a2,2,0,0,1-2-2V331.18A2,2,0,0,1,129.34,329.21Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M132.77,335.5a.57.57,0,1,1,0-1.13h46.82a.57.57,0,1,1,0,1.13Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M132.77,341.48a.57.57,0,1,1,0-1.13H140a.57.57,0,1,1,0,1.13Zm9.84,0a.57.57,0,1,1,0-1.13h37a.57.57,0,1,1,0,1.13Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M132.77,347.47a.57.57,0,0,1,0-1.14H153.1a.57.57,0,1,1,0,1.14Zm28.47,0a.57.57,0,0,1,0-1.14h18.35a.57.57,0,1,1,0,1.14Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M132.77,353.06a.57.57,0,1,1,0-1.13h34.09a.57.57,0,0,1,0,1.13Zm42.22,0a.57.57,0,0,1,0-1.13h4.6a.57.57,0,1,1,0,1.13Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M195,38.17h28.44A17.65,17.65,0,0,1,241,55.76V82.83a17.63,17.63,0,0,1-17.59,17.59H195a17.63,17.63,0,0,1-17.59-17.59V55.76A17.65,17.65,0,0,1,195,38.17Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 53.17,
    height: 51.92,
    x: 182.59,
    y: 43.34,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    rx: 13.63
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M121.19,191.61a.76.76,0,0,0,1.51.14h0l-1.51-.13a17.18,17.18,0,0,1,.7-3.1.76.76,0,0,1,1.45.44,17.06,17.06,0,0,0-.64,2.79l-1.51-.13Zm150.09,13.54a.76.76,0,0,0-1.18-1,29.3,29.3,0,0,1-2,2.2.76.76,0,0,0,1.08,1.07c.72-.74,1.41-1.51,2.06-2.32Zm-5.55,5.38a.76.76,0,0,0-.92-1.21c-.79.6-1.59,1.16-2.43,1.69a.76.76,0,0,0,.81,1.28c.88-.55,1.71-1.14,2.54-1.76Zm-6.58,4a.76.76,0,0,0-.65-1.37c-.89.43-1.8.83-2.72,1.2a.76.76,0,0,0,.55,1.41c1-.39,1.89-.8,2.82-1.24ZM252,217.25a.75.75,0,0,0-.4-1.45c-.95.26-1.92.51-2.89.71A.76.76,0,0,0,249,218c1-.22,2-.46,3-.74Zm-7.54,1.45a.75.75,0,0,0-.15-1.5c-1,.07-2,.17-3,.21a.76.76,0,0,0,0,1.51c1.05,0,2-.14,3.07-.22Zm-7.69.13a.75.75,0,0,0,.12-1.5c-1-.08-2-.18-2.95-.33a.75.75,0,0,0-.23,1.49c1,.16,2,.27,3.06.34Zm-7.58-1.3a.76.76,0,0,0,.41-1.46c-.95-.25-1.9-.57-2.82-.91a.75.75,0,0,0-.53,1.41,30.57,30.57,0,0,0,2.94,1ZM222,214.66a.75.75,0,0,0,.73-1.32,26.9,26.9,0,0,1-2.53-1.52.76.76,0,0,0-.85,1.25c.85.57,1.75,1.11,2.65,1.59Zm-6.32-4.43a.76.76,0,0,0,1-1.12,29.58,29.58,0,0,1-2.11-2.08.75.75,0,0,0-1.11,1,30.16,30.16,0,0,0,2.2,2.18Zm-5.1-5.8a.76.76,0,0,0,1.25-.85c-.56-.82-1.08-1.65-1.58-2.51a.75.75,0,0,0-1.31.75c.51.89,1.05,1.75,1.64,2.61Zm-3.72-6.69a.76.76,0,0,0,1.35-.68c-.45-.91-.93-1.81-1.42-2.7a.75.75,0,0,0-1.32.73c.48.87.94,1.76,1.39,2.65Zm-3.67-6.52a.76.76,0,0,0,1.28-.81c-.55-.86-1.11-1.71-1.69-2.55a.75.75,0,0,0-1.24.86c.57.83,1.12,1.65,1.65,2.5Zm-4.34-6.08a.75.75,0,0,0,1.17-.95c-.64-.8-1.31-1.57-2-2.33a.76.76,0,0,0-1.12,1c.66.74,1.31,1.49,1.94,2.26Zm-5.09-5.44a.76.76,0,0,0,1-1.11c-.76-.7-1.53-1.36-2.32-2a.76.76,0,0,0-1,1.17c.78.63,1.52,1.28,2.25,1.95Zm-5.84-4.58a.76.76,0,0,0,.82-1.27c-.86-.56-1.73-1.09-2.63-1.6a.76.76,0,0,0-.73,1.33c.86.48,1.71,1,2.54,1.54Zm-6.54-3.51a.76.76,0,0,0,.6-1.39c-1-.41-1.9-.77-2.88-1.11a.76.76,0,0,0-.49,1.43c.94.33,1.85.68,2.77,1.07Zm-7.05-2.31a.75.75,0,0,0,.34-1.47c-1-.23-2-.43-3-.6a.76.76,0,0,0-.24,1.5c1,.16,2,.35,2.92.57ZM167,168.21a.76.76,0,0,0,.1-1.51c-1-.07-2-.11-3.07-.13a.76.76,0,0,0,0,1.52c1,0,2,0,3,.12Zm-7.47,0a.76.76,0,0,0-.08-1.51c-1,.05-2,.12-3,.2a.76.76,0,0,0,.14,1.51c1-.11,2-.16,3-.2Zm-7.45.71a.75.75,0,0,0-.23-1.49c-1,.14-2.06.3-3,.52a.76.76,0,0,0,.31,1.48c1-.19,2-.37,2.94-.51Zm-7.29,1.57a.75.75,0,0,0-.42-1.45c-1,.28-2,.6-2.93.95a.76.76,0,0,0,.52,1.42c.93-.34,1.88-.64,2.83-.92Zm-6.92,2.66a.76.76,0,0,0-.68-1.36c-.92.46-1.83.95-2.71,1.48a.76.76,0,0,0,.79,1.29c.83-.51,1.72-1,2.6-1.41Zm-6.23,4a.75.75,0,0,0-.95-1.17,28.51,28.51,0,0,0-2.3,2.09.76.76,0,0,0,1.08,1.06,23.91,23.91,0,0,1,2.17-2Zm-5,5.36a.75.75,0,0,0-1.23-.87,26.44,26.44,0,0,0-1.64,2.64.76.76,0,0,0,1.33.72A25.23,25.23,0,0,1,126.59,182.43Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M489.94,140.64H438.59a2.24,2.24,0,0,0-2.23,2.23v28.64h0v11c0,.56.09,1.16.73.44l9.81-9.29h43a2.23,2.23,0,0,0,2.23-2.23V142.87A2.24,2.24,0,0,0,489.94,140.64Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M486.92,146.53a.57.57,0,0,1,0,1.14h-35.2a.57.57,0,1,1,0-1.14Zm-37.11,0a.57.57,0,0,1,0,1.14h-8.36a.57.57,0,1,1,0-1.14Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M486.92,153.28a.57.57,0,1,1,0,1.13H466.57a.57.57,0,1,1,0-1.13Zm-22.27,0a.57.57,0,1,1,0,1.13h-23.2a.57.57,0,1,1,0-1.13Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M486.92,160a.57.57,0,1,1,0,1.13H441.45a.57.57,0,1,1,0-1.13Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M486.92,166.32a.57.57,0,1,1,0,1.14H458.59a.57.57,0,1,1,0-1.14Zm-30.25,0a.57.57,0,1,1,0,1.14H441.45a.57.57,0,1,1,0-1.14Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 30.48,
    height: 28.57,
    x: 120.59,
    y: 267.29,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    rx: 4.03
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M275.15,192.59a.75.75,0,1,1-1.42.5l-.92-2.54a.75.75,0,0,1,1.42-.51Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M280.59,194.56a.76.76,0,0,1-1.06-.14.75.75,0,0,1,.13-1.06l2.55-2a.76.76,0,0,1,.92,1.2Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M281.59,199.55a.75.75,0,1,1,.33-1.47l3.7.83a.75.75,0,1,1-.34,1.47Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M276.62,202.35a.75.75,0,1,1,1.5-.17l.33,2.87a.75.75,0,1,1-1.5.17Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M271.2,196.58a.75.75,0,1,1,.05,1.5l-3.74.13a.75.75,0,0,1-.78-.73.76.76,0,0,1,.73-.78Z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M276.59,194.4a2.88,2.88,0,0,1,2,.85h0a2.89,2.89,0,1,1-2.05-.85Zm.44,2.45a.61.61,0,0,0-.44-.18.63.63,0,0,0-.44.18.65.65,0,0,0-.18.44.61.61,0,0,0,.18.44.6.6,0,0,0,.44.19.58.58,0,0,0,.44-.19.56.56,0,0,0,.18-.44.62.62,0,0,0-.17-.44Z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M242.7,245.11l-1.24.26,21.19,43,38.52-9.51L304.6,276M309,272.4l21.42-17.86-26.32-41.06-.78.72"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M243.22,239.85l-.53,6.12,20.2,42,28-6.88M309,272l20-17.61-.7-1.54"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M308.54,269.07l18.92-16.44-25.08-38.46-25,20.64L277,235l-32.72,5.45,19.91,42.31L300.44,276l2.89-2.5.46.53.25.85-2.77,2.39-.35.17-37.56,7q-10.62-22.57-21.25-45.16l34.48-5.75,26.13-21.59,26.72,41-20.9,18.17h0A7,7,0,0,1,308.54,269.07Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    points: "248.62 242.36 275.13 237.85 280.97 247.49 253.56 252.97 248.62 242.36"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 256.26,
    x2: 283.04,
    y1: 258.04,
    y2: 252.3,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 258.11,
    x2: 284.63,
    y1: 261.75,
    y2: 255.65,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 261.12,
    x2: 286.66,
    y1: 266,
    y2: 259.54,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 263.06,
    x2: 288.87,
    y1: 270.42,
    y2: 263.96,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 267.66,
    x2: 290.38,
    y1: 274.48,
    y2: 268.03,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M303.74,273.89a11.1,11.1,0,0,1-.12-7.2c1.28-3.9,5.62-1.63,5.12,1.1s-.36,3.9.8,5.37.64,3.71,2.66,4.89a42.86,42.86,0,0,0,5.49,2c-1.44,2.42-1.66,6.63-1.79,10.12-3.38-1-6.56-1.91-7-2s-7.27,1-10.49-.75a33.27,33.27,0,0,1-7.33-5.82l10-2.7,3.3-2.79Z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M414.49,455.43s-17.75,3.88-18.92,7.78c-.85,2.82,14.48,2.7,23,1.54,3.51-.48,5.49.09,4.31-9.32"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M414.49,455.43s-9.58,2-14.89,4.64c5.51,3.05,17.93-1.63,23.3-4.64v-8.87c-2.39.74-6.74,2-8.41,2.45Z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M385.47,448.09v7.34s-11,2-17.11,4.64c6.33,3.05,20.61-1.63,26.79-4.64v-5.75l-.88-.08C391.5,449.35,386.66,448.35,385.47,448.09Z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M369.78,358.94c0,.49-.07,1-.11,1.51-.15,2.35-.28,5.13-.32,8.79-.08,8.66.55,19.78,1.4,31.28,1.17,15.79,2.74,32.32,3.42,44.2,13,4.77,25.91,6.55,38.58,4.43a66,66,0,0,0,19-6.28L431,384.53l3.73-27.35"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M434,185.56a23.16,23.16,0,0,1,10.5,5c6.64,5.66,6.83,17.21,4.41,26.53a41.6,41.6,0,0,1-2,5.93,22,22,0,0,1-15.3,13c-5.19,1.37-9.46,1.72-13.87.05"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M434.05,186.24c8.36,10.18,4.61,40.36-12.54,46.83"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M389.25,242.86c-4,1.2-11.39,5.06-11.81,9.74-.65,8.67-15.17,21.76-22.16,25.46-6.08.58-30.79,3.16-36.66.88-3,2.62-2.53,10.75-2.91,14.78,5.92,1.18,31.76,4.34,41.54,4A58.15,58.15,0,0,0,365,297c3.35-.57,4.81-1.85,9.51-6.53l.56-.55"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M388.33,243.19c3.72-1.4,9-2.15,14.35-2.43m14.59.39a37.09,37.09,0,0,1,13.21,4c3.07,1.31,5.29,3.15,5.85,5.8m-2.26,63.87c3.88,16,8.18,37.95,8.18,37.95a58.75,58.75,0,0,1-45.62,7.46c-3.79-1-6.7-15-6.7-15s-5.36,11.47-11.88,13.28A22.21,22.21,0,0,1,369,359a22.82,22.82,0,0,1-3.95-.91c.31-17.79,5.33-38.38,9.2-52.62a37.79,37.79,0,0,0,1-5.82c1.56-15-6.82-28.45,4.2-42.57a19.29,19.29,0,0,0,3.4-8.07"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M397.52,250.15c-2.26,4.55-3.56,9-3.41,16.52,4.22-7.58,7.75-11.58,13.4-14.82"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M376.07,205.9h.21c1.17,3,2.42,7.33,1.61,11.19-1.38,6.53-1.56,13.06,8.59,18.19,5.06,2.57,11.91,3,18.26,2.2a10.64,10.64,0,0,1-.37,2.7l-1,0c-1.84,2.05-4.14,7-2.5,11.19,6.67-.87,18.17-5.42,23.59-9.26-1-.31-2-.58-3.09-.83a35.51,35.51,0,0,0-3.95-.66l.08-1.11a45.92,45.92,0,0,0,.1-5.36,18.87,18.87,0,0,0,2.48-1.29c-3.15-.13-6.46-12.29-2.28-12.73s5.56-2.55,6.78-5.6.83-9.86-3.46-10-5,7.66-5.62,6.6,1.22-3.66-1.47-7.08-1.71-10-1.71-10c-7,2.37-28.31,7-38.51,3.42v.13l0,.11h0l0,.12,0,.13,0,.12h0l0,.13,0,.12,0,.13V199l0,.06,0,.12,0,.1v0l0,.12,0,.12h0l0,.12,0,.25,0,.12,0,.13,0,.12,0,.08v0l0,.13,0,.1v0l0,.12,0,.13h0l0,.11,0,.13v0l0,.09,0,.12v.07l0,.06,0,.12,0,.09v0l0,.13,0,.11h0l0,.12,0,.13v0l0,.1,0,.12,0,0,0,.08,0,.12,0,.08v0l.08.23v0l0,.13,0,.12h0l0,.12,0,.13,0,0,0,.09,0,.12,0,.06,0,.07,0,.12,0,.09,0,0,.08.23h0l.05.13,0,.12v0l0,.1.05.13,0,0,0,.08.05.13,0,.07,0,.05.05.12,0,.1v0l0,.12Z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M368.73,193.8h0c.47,6.2,3.15,9.25,7.55,12.61q-.11-.27-.21-.51A32,32,0,0,1,373.8,198c10.2,3.61,31.54-1.05,38.51-3.42,0,0-1,6.6,1.71,10s.88,6,1.47,7.08,1.34-6.76,5.62-6.6,4.69,7,3.46,10-2.61,5.16-6.78,5.6-.87,12.6,2.28,12.73c14-4.7,18.89-33.33,13.86-47.62-3.82-10.86-11.89-18.66-21.53-21-14.47-3.5-25.87.91-29.66,4s-2.08,7.58-2.08,7.58-6.72-1.17-10.14,4S368.73,193.8,368.73,193.8Z"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    points: "400.49 251.92 407.73 251.8 409.16 259.02 415.24 250.25 429.61 244.72 424.62 242.72"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    points: "403.44 240.75 398.69 241.06 397.98 246 393.38 252.42 397.93 250 400.93 251.97"
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    points: "425.78 371.72 421.38 395.53 421.64 446.63"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M385.47,455.43s-20.4,3.88-21.75,7.78c-1,2.82,16.65,2.7,26.46,1.54,4-.48,6.32.09,5-9.32"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M418,333.24a16.63,16.63,0,0,1-1.59,6c-1.46,3-5,5.55-9.42,6.91s-8.19-6.25-5.63-7.66,9.63-7.58,5.57-5.61c-1.53.75-2.67,1.65-3.06,1.4s-.6-2.34,1.49-3.67a8,8,0,0,1,7.07-.88l.87-1.1a11.7,11.7,0,0,0,5.35,3.64Z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M422.51,278.21a157.15,157.15,0,0,0,6.85,15.8l.1,0c-4.59,9.45-12.2,24-17.27,33.1,1.77,2.91,5.6,5.77,8.89,5.37,3-3.37,18.07-24.28,20.74-30.45a49.79,49.79,0,0,0,1.7-5.77c-1.16-12.2-2.36-41.92-9.7-49.13"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M237.4,417.59a66.88,66.88,0,0,1-7.82,27.73,9.88,9.88,0,0,0-4.44,3.7c1.88-5.4,2.24-11.1,2.6-16.69.36-5.77.4-11.22.25-14.67C230.23,418.14,234.61,417.9,237.4,417.59Z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M239.2,450.05s-1.68-5-6.77-5.19-7.74,4.89-7.74,4.89Z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M215.5,419.43a66.85,66.85,0,0,1-7.69,25.89,9.82,9.82,0,0,0-4.44,3.7c1.88-5.4,2.24-11.1,2.59-16.69.33-5,.39-9.82.3-13.25A79.21,79.21,0,0,0,215.5,419.43Z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M217.43,450.05s-1.68-5-6.77-5.19-7.74,4.89-7.74,4.89Z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M200.47,392.53l-1.27,23.28c-.28,5.15,24,3.41,26.74,3.07a1.71,1.71,0,0,0,.62-2.11c.2,1.82,9.62,1.08,12.53.59,6-1,3.93-3.2,3.93-3.2l-1.4-19.33"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M240,352l-.28-2.07c-.41-3-.82-5.9-1.19-8.79a7.06,7.06,0,0,0-3.12-4.51,22.4,22.4,0,0,0-5.17-2.72,19.54,19.54,0,0,0,.42,2.38,10.28,10.28,0,0,0,.76,2.22,1.67,1.67,0,0,1,.17,1.2,1.47,1.47,0,0,1-.86.92,3.82,3.82,0,0,1-1.4.29,7.87,7.87,0,0,1-4.52-1.38,17.38,17.38,0,0,1-2.55-2.44c-1.35-1.48-2.64-2.9-4.64-3.05l-.27,0-.07-.27c0-.16-.07-.35-.1-.55l0-.25-.83.21c-.43.12-.86.24-1.28.38h0a29.56,29.56,0,0,0-8.3,3.21,11.24,11.24,0,0,0-4.5,4.41c-.43.88-.84,1.89-1.23,2.92s-.82,2.34-1.15,3.44l-.72-.21c.32-1.1.72-2.31,1.17-3.5s.81-2.07,1.25-3a11.85,11.85,0,0,1,4.79-4.73,30.16,30.16,0,0,1,8.51-3.3l1.3-.39c.44-.11.87-.22,1.29-.31l.43-.09,0,.44a5.4,5.4,0,0,0,.06.63l0,.22c2.13.27,3.46,1.73,4.86,3.26a16.38,16.38,0,0,0,2.44,2.34,7,7,0,0,0,4,1.23,2.79,2.79,0,0,0,1.12-.22.72.72,0,0,0,.44-.43.93.93,0,0,0-.12-.67,11.8,11.8,0,0,1-.82-2.38,23.89,23.89,0,0,1-.5-3.08l-.06-.6.57.21a23.75,23.75,0,0,1,5.93,3,7.75,7.75,0,0,1,3.41,5c.37,2.83.78,5.79,1.19,8.78l.31,2.2v.12Z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M201.32,371.88c-.3,2.58-.56,5.06-.77,7.37s-.39,4.56-.51,6.55a13.29,13.29,0,0,1-.54,3.79,2.49,2.49,0,0,0-.11,1.16,1,1,0,0,0,.1.4c.83,1.73,5.62,3.07,11.78,3.92a114.65,114.65,0,0,0,20.22.87c4.83-.24,8.91-.85,11-1.87,1.78-.85,1.22-2.36.64-3.94a7.07,7.07,0,0,1-.65-3.13q.09-.76.15-1.59c0-.56.07-1.13.09-1.7v0l.75.08c0,.6,0,1.16-.09,1.7s-.09,1.1-.15,1.63a6.52,6.52,0,0,0,.61,2.78c.71,1.91,1.38,3.74-1,4.89-2.23,1.06-6.41,1.69-11.34,1.94a116.13,116.13,0,0,1-20.35-.88c-6.4-.88-11.41-2.36-12.36-4.34a2.2,2.2,0,0,1-.18-.69,3,3,0,0,1,.16-1.44,13.32,13.32,0,0,0,.5-3.6c.12-2,.29-4.18.51-6.57s.48-4.86.77-7.39Z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M212.19,345.53c-.51,7.24-2,16.79-1.39,18.9s-9.8,2.33-12.13.3c-1.43-1.25-1.34-9.58.78-17.43"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M230.24,375.14l-.85,7.1,20.94,2.25L254,354.83l-20.79-4.14-1.78,14.78m-.12,1-.27,2.26"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    points: "252.36 345.66 253.96 354.83 249.24 353.89 252.36 345.66"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M200.11,365.44a22.45,22.45,0,0,0,.63,5.55c2.49,8.3,15.91,7.55,28.48,4.18,0,0,2.49.21,6.56-1.61,2-.9,2.81-4.15,2.24-5.46-1.09-2.53-5.06,1.59-7,.66,0,0-.25-1.82.33-2.29s.28-1.28-.66-1.16-2.43,2.76-2.47,3.51c-.07,1.58-21.24,6.77-21-2.76-.56,0-1.34.08-2.38.07A20.36,20.36,0,0,1,200.11,365.44Z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M243.42,292.3c-.06,14.59,4.21,13.12,5.33,21.14,1.46,10.41-8.3,18.24-19.09,18.94a17.83,17.83,0,0,0,1.37,6.33c1.15,2.34-3.46,2.44-6.05.56s-4.06-5.3-7.38-5.56a16.52,16.52,0,0,1-.17-3.9,22.21,22.21,0,0,1-2.55-1.61c6.26-1.22,3.79-7-.77-8.06.51-5-2.69-3.61-2.69-3.61-.74,2.14-6.16,2.6-7.81-2.76-1.12-3.66.08-8.86,3.37-7.55,1.11.44,2.06.76,2-1.33-.17-4.43-2.21-3.69-.25-7.62a3.91,3.91,0,0,1,1.52-1.71l1.16-.45c2.2-.5,5.05.46,7.57.11,3.76-.53,3.49-6.36,12.78-3.12A17.89,17.89,0,0,0,243.42,292.3Z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M241.84,310.4a.74.74,0,0,1-.81.69.75.75,0,0,1-.7-.81.86.86,0,0,0,0-.34.34.34,0,0,0-.1-.16l-.07,0a1.27,1.27,0,0,0-.77-.09,1.2,1.2,0,0,0-.69.31l-.06.08a.88.88,0,0,0-.08.26,2.52,2.52,0,0,0,0,.47.76.76,0,0,1-.66.84.77.77,0,0,1-.84-.67,3.77,3.77,0,0,1,0-.82,2.27,2.27,0,0,1,.26-.81,1.72,1.72,0,0,1,.25-.35v0a2.74,2.74,0,0,1,1.59-.79,2.89,2.89,0,0,1,1.71.26,1.6,1.6,0,0,1,.31.22l.06,0a2,2,0,0,1,.51.8A2.2,2.2,0,0,1,241.84,310.4Z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M219,295.22c-3.77.53-8.28-1.89-10.25,2s.08,3.19.25,7.62c.08,2.09-.87,1.77-2,1.33-3.29-1.31-4.49,3.89-3.37,7.55,1.65,5.36,7.07,4.9,7.81,2.76,0,0,3.2-1.43,2.69,3.61,5.81,1.4,8.23,10.32-6.46,7.86-10,3.8-17.72-6.66-13.78-12.4-12.89,1.74-20.92-35.79-.71-38.3-4.35-10.63,11.32-17.83,16.36-12.31,2.26-6.49,17.24-8.81,19.46,1.18,8.62-7.49,20,2.27,17.68,12,11.75,4.93-.44,19-14.92,13.93C222.45,288.86,222.72,294.69,219,295.22Z"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    points: "252.36 345.66 253.96 354.83 249.24 353.89 252.36 345.66"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M230.13,404.23c-2.25.07-3.34.51-3.49,2.9s-.1,8.07-.09,8.91"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M213.66,395.85c0,.49-.12.95-.2,1.39-1.52,8.67-6.61,7.71-6.79,7.39"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 206.86,
    x2: 205.91,
    y1: 394.71,
    y2: 418.96,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M120.64,245.23a.76.76,0,0,1,0-1.52H186.8a.76.76,0,0,1,0,1.52Z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M120.64,254.4a.76.76,0,0,1,0-1.52H186.8a.76.76,0,1,1,0,1.52Z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M120.64,250.13a.76.76,0,0,1,0-1.51H186.8a.76.76,0,1,1,0,1.51Z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M339.26,232.25c-3.08-10.38-10.73-8.47-11.87-14.62-3.27-17.61,29.06-15.33,22-1.92A13.13,13.13,0,0,0,349.2,228a12.56,12.56,0,0,0-1.23.36c-2.81.94-7.61,3.21-7.61,3.21S339.86,231.84,339.26,232.25Z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M340.36,231.57s-2.71,1.45-3,2.73,1.14,1.52,2.46,1.32-.57.2-.3,1.85,2.13-.32,3.45.46.12,2.53,2,2.26,7.82-2.91,7.67-3.79-2.47-1.62-1.47-2.52,2.95-2.75,1.11-2.9-.38-1.1,0-2.27-1.46-1.29-4.26-.35S340.36,231.57,340.36,231.57Z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M342,235a.37.37,0,0,1-.48-.22.36.36,0,0,1,.22-.48l.26-.1a52.19,52.19,0,0,0,7.77-3.39.37.37,0,0,1,.51.14.38.38,0,0,1-.14.52,52.35,52.35,0,0,1-7.87,3.43Z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M344.14,237.44a.38.38,0,0,1-.48-.22.38.38,0,0,1,.22-.49l.4-.15a40.76,40.76,0,0,0,5.27-2.26.38.38,0,0,1,.36.67,44.33,44.33,0,0,1-5.36,2.3Z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M342.1,230.77s-2.31-6.72-4.06-9.2-4.65-2.29-4.75-4.87,3.14-2.43,3.34-1.49-.39,3-.87,1.59,1.1-4.46,3-2.54-.45,3.11-.81,1.49,2.15-4.86,3.36-2.72-.36,4-.77,1.65,2.82-4.05,3.67-2-1.16,5.44-.62,7.63,2.5,8.77,2.5,8.77"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M315.34,210.55a1.13,1.13,0,1,1,.23-2.25l7,.74a1.13,1.13,0,0,1-.23,2.25Z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M321.59,197.49a1.13,1.13,0,1,1,1.59-1.6l5,5a1.13,1.13,0,0,1-1.6,1.61Z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M336.46,191.79a1.13,1.13,0,0,1,2.26,0l0,7.07a1.13,1.13,0,0,1-2.26,0Z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M353.28,195.88a1.13,1.13,0,0,1,1.6.05,1.14,1.14,0,0,1-.05,1.6l-5.16,4.83a1.13,1.13,0,0,1-1.55-1.65Z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.75,
    d: "M87.65,256c-.05.37-.08.75-.1,1.13h0l-.2,1.94-.64,0a16.68,16.68,0,0,1,.84-6.32l.1-.26Z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.75,
    d: "M12.05,256.13c12.46,4.47,26.38,9.23,40.46,13.31a315.72,315.72,0,0,0,35.14,8.27v1a316.25,316.25,0,0,1-35.42-8.33c-14.07-4.08-28-8.84-40.51-13.33Z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.75,
    d: "M70.52,258.18a46.86,46.86,0,0,0,1,8.84,36,36,0,0,0,3.06,8.31l-.88.44a37.31,37.31,0,0,1-3.14-8.53,48,48,0,0,1-1-9Z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.75,
    d: "M54.36,252.53a23.13,23.13,0,0,0,1,10.37,48.86,48.86,0,0,0,3.82,8.56l-.87.47a50,50,0,0,1-3.88-8.74,23.86,23.86,0,0,1-1-10.81Z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.75,
    d: "M58.05,287.43a16.41,16.41,0,0,1,2.82-7.86,18.28,18.28,0,0,1,6.37-6l.45.87a17.25,17.25,0,0,0-6,5.7A15.4,15.4,0,0,0,59,287.49Z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.75,
    d: "M44.09,282.37a16.83,16.83,0,0,1,2.54-7.45h0a22.14,22.14,0,0,1,5.3-5.44l.59.77a21.39,21.39,0,0,0-5.06,5.2,15.88,15.88,0,0,0-2.39,7Z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.75,
    d: "M32.65,275.82c.06-1.4,1.18-3.27,2.74-5a21.64,21.64,0,0,1,5.72-4.65l.45.87a20.61,20.61,0,0,0-5.44,4.44c-1.42,1.6-2.45,3.25-2.49,4.41Z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.75,
    d: "M32.2,253.27a14.82,14.82,0,0,0,1,5.62,20.92,20.92,0,0,0,3,5.61l-.78.59a21.92,21.92,0,0,1-3.13-5.87,16,16,0,0,1-1-6Z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.75,
    d: "M20.57,268.09a51.63,51.63,0,0,1,4-3.42,21.81,21.81,0,0,1,4.33-2.53l.4.89a20.68,20.68,0,0,0-4.14,2.42,49.82,49.82,0,0,0-3.91,3.36Z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.75,
    d: "M70.89,290.3a16.49,16.49,0,0,1,2.82-7.87,18.24,18.24,0,0,1,6.37-6l.45.87a17.36,17.36,0,0,0-6,5.7,15.39,15.39,0,0,0-2.65,7.38Z"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 262.89,
    x2: 263.8,
    y1: 287.96,
    y2: 283.59,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M393,218.27a.75.75,0,1,1-1.47.34,3.3,3.3,0,0,0-1.94-2.52l0,0a2.82,2.82,0,0,0-1.21-.17,2.57,2.57,0,0,0-1.1.32,1.53,1.53,0,0,0-.81,1.3.76.76,0,0,1-1.51,0,3,3,0,0,1,1.56-2.58,4.12,4.12,0,0,1,1.75-.53,4.35,4.35,0,0,1,1.87.28h0A4.76,4.76,0,0,1,393,218.27Z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M372.94,310.06H247.85m-63.11,0h-72.2a6.44,6.44,0,0,1-6.43-6.43V136.82a6.45,6.45,0,0,1,6.43-6.44H397.28a6.45,6.45,0,0,1,6.43,6.44v26.89"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M192.89,61.28h0a2.3,2.3,0,0,0,1.05,3.08l15.6,7.69a2.31,2.31,0,0,0,3.08-1h0a2.31,2.31,0,0,0-1.05-3.09L196,60.23A2.3,2.3,0,0,0,192.89,61.28Z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 4.61,
    height: 22,
    x: 208.3,
    y: 49.62,
    rx: 2.3
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M140.24,150.88l.14,1.72v-.43l.14.86.15.43.14.29.14.28.29.15.14.43.29.14.14.43.29.15.14.28h.29l.14.29H143l.29.14.14.29h.29l.29.14.71.15h.86l.58-.15.29-.14.28-.14.15-.15.28-.28.15-.15.28-.28v-.15l.29-.29H148l.15,1.44.14.14.14.72.29.14.14.29.15.15h1l.58-.29.14-.29.14-.43V156l-.14-.43-.14-1.14-.15-.58-.14-.57-.14-1.44-.15-.72-.14-.71-.14-.86-.15-1.3-.14-.43-.14-.28-.29-.29-.29-.29-.29-.14-.14-.14-.43-.15-.57-.14-.29-.14-.57-.15h-1.87l-.43.15-.29.14-.28.14-.29.15-.29.14-.29.29-.28.14-.29.29-.14.14-.29.29-.14.28-.15.15-.28.29-.15.14-.14.28-.14.15-.15.43-.14.57-.14.58Zm5,3h-.43l-.29-.14-.29-.15-.28-.14-.15-.29-.28-.14-.15-.29-.14-.29L143,152v-.29l.14-1.15h0l.15-.14.14-.29.29-.29.14-.14.29-.29.14-.14.43-.29.29-.14h1.29l.29.14.29.14-.29,1.44.14-.29-.28.86-.15.58-.14.43-.15.43-.14.43-.14.29-.15.14-.28.43Z",
    opacity: 0.6
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M123.77,153.78l.22,2.09v-.63l.2.84h.22v.21h.2l.22.42h1.25l.63-.2.42-.22.21-.42.21-.63.21-1.46.21-1.9,1.68-.21,2.1-.21,1.89-.21h.21l.21,1.05.21.42.21.64.21.84.21,1.25.21.63.21.85.42.2.21.42.21.21h1.47l.84-.42.21-.41.21-.64V155l-.21-1.05-.21-.62-.21-.84-.21-.85-.21-.42-.21-.42-.21-1-.21-.42L137,149l-.21-.42-.21-.42-.21-.63-.21-.42-.21-.42-.21-.42-.21-.42-.42-.63-.21-.42-.21-.21-.21-.42-.42-.42-.21-.43-.42-.42-.21-.41-.42-.42-.21-.42-.42-.21L132,141l-.42-.21-.42-.42-.42-.21-.63-.21h-.63l-.63.21-.42.21-.42.42-.42.21-.42.63-.21.42-.21.21-.21.42-.21.62-.21.43-.21.42-.21.63-.21,1.05-.21.62-.21.64-.2.63-.22.63-.2,1.47-.22,1.26-.2,1-.22,1.68Zm6.09-6.09H129l.21-1.05.21-.42.21-1.05h0l.21-.42.42.21.21.63.42.21.21.62.42.22.21.62v.43Z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M174.61,146l.15,4.16v-1.43l.14,3.58.14.14v1.87h0v.15l.14.86h0l.15,1.43v-.43l.14.86.29.14.14.29.15.15h.86l1.86-.29-.57.14,1.29-.29.57-.14.43-.14.43-.15.29-.14.29-.14.14-.15.43-.28.15-.15.28-.28v-.15l.29-.28v-.15l.14-.29.15-.28.14-.29v-2.44l-.14-.29-.15-.42-.14-.29-.14-.29-.15-.29-.28-.43-.15-.28-.29-.15-.28-.29-.29-.14-.29-.28-.28-.15-.43-.14h-1.29l-.44.14-.28.15-.29.28-.29.14h-.14l-.14-.57v-2.73h0v-.28l-.29-.29-.14-.29-.29-.14-.29-.14h-.43l-.43.14-.29.29-.14.14-.28.29-.15.43Zm4.16,8.75h-.86l.15-2V153l.14-.58.14-.28.29-.29.14-.14.29-.29.14-.14.43-.14h.15v.14h.14l.14.28.29.15.14.57v1.58l-.14.14-.29.29-.28.15-.43.14Z",
    opacity: 0.6
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    points: "208.24 152.6 208.38 154.18 208.38 153.75 208.52 154.61 208.67 155.04 208.81 155.33 209.1 155.47 209.24 155.9 209.53 156.04 209.67 156.33 209.96 156.48 210.24 156.62 210.39 156.91 210.68 156.91 210.82 157.19 211.1 157.19 211.39 157.34 211.97 157.48 212.54 157.62 213.26 157.77 214.26 157.77 215.27 157.62 216.27 157.48 216.7 157.34 217.13 157.19 217.56 157.05 217.85 156.91 218.14 156.76 218.28 156.48 218.42 156.04 218.42 155.47 218.28 155.04 218.14 154.75 217.85 154.61 217.71 154.47 217.13 154.32 216.56 154.47 216.27 154.75 215.41 154.9 214.41 155.04 213.11 155.04 212.54 154.9 212.25 154.75 211.97 154.61 211.68 154.47 211.39 154.18 211.1 153.89 210.96 153.46 210.96 152.6 211.1 152.17 211.25 151.88 211.53 151.6 211.68 151.31 211.97 151.02 212.11 150.88 212.54 150.59 212.68 150.45 213.11 150.16 213.4 150.02 213.54 149.88 214.12 149.59 215.55 149.44 215.98 149.3 216.27 149.16 216.41 148.87 216.56 148.44 216.56 148.01 216.41 147.58 216.27 147.29 215.98 147.15 215.84 147 214.12 146.86 214.12 146.86 213.4 147 212.97 147.15 212.68 147.29 212.4 147.44 212.11 147.72 211.82 147.87 211.53 148.01 211.25 148.3 210.96 148.44 210.68 148.58 210.39 148.87 210.1 149.01 209.81 149.3 209.67 149.59 209.53 149.73 209.24 150.16 209.1 150.3 208.81 150.88 208.67 151.16 208.52 151.6 208.38 152.03 208.24 152.6 208.24 152.6",
    opacity: 0.6
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M239.59,151.45l.14,1.29.14.15L240,154l.14.29.14.29.15.29.28.14.15.43.28.14.15.29.28.14.29.15.14.28h.29l.29.15.43.14.57.14.58.15h.43l.57-.15.58-.14.43-.14.28-.15.29-.14.29-.14.28-.15.15-.14.28-.29h.15l.14,1.15v-.14l.14.57.29.14.15.29.43.15h.43l.57-.15.14-.14.29-.29.14-.43.15-.29-.29-1.14-.14-1.58-.15-1.29v-1.58l.15-.43V150l-.15-.43-.14-.29-.29-4.59.15.14-.29-.57-.14-.29-.29-.14-.43-.29h-.29l-.72.14-.28.15-.15.28-.14.15-.14.43v1l.14.29-.29,2-.86-.29h-.28l-1.15-.14-.29.14-1.43.14H243l-.58.15-.28.14-.29.14-.29.15-.28.14-.29.15-.29.28-.14.15-.29.43-.14.28-.14.29-.15.29-.14.28-.14.72Zm5,2.87h-.43l-.58-.14-.28-.15-.15-.28-.28-.15-.15-.28-.14-.15-.29-1v-.29l.14-.71h0l.15-.29.57-.29.29-.14,1-.15h1l.43.15.72.14.43.14-.15.29-.14.43-.14.43-.15.72-.14.29-.14.28-.15.29-.14.29-.14.14-.29.14-.29.15-.57.14Zm2.72-6.31h0Z",
    opacity: 0.6
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M273.16,152l.15,1.43.14.15.14.86.15.14.14.57.14.29.29.14v.29l.29.14v.29l.28.14.15.29.43.15.14.28.43.14.29.15.57.14.58.15h2.58l.86-.15.72-.14.43-.15.29-.14.14-.14.14-.29.15-.43v-.43l-.15-.43-.14-.29-.29-.29-.43-.14h-.29l-.57.14-.72.15h-2.72l-.29-.15-.29-.14v-.14l2-.29-.43.15,1-.29.58-.15.29-.14.28-.14.15-.14.43-.29.14-.15.14-.28.29-.29.14-.14.15-.29.14-.43.15-.86v-.72l-.15-.43-.14-.29-.15-.43-.14-.28-.14-.29-.15-.29-.28-.14-.15-.29-.28-.14-.29-.15-.29-.14-.14-.14-.29-.15-.43-.14-.86-.14h-.29l-.86.14-.71.14-.44.15-.28.14-.29.14-.29.29-.14.15-.29.28-.14.14-.29.29-.14.29-.14.14-.15.29-.14.14-.14.29-.15.43-.14.57-.14.58-.15.72Zm5.17-.29h-1.44l-.28-.15-.29-.14-.15-.28.15-.15.14-.29.15-.43.14-.28.29-.29.28-.14.72-.15h.43l.43.15.29.14.14.29.29.14V151l-.15.15-.28.28-.29.14Z",
    opacity: 0.6
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M158.15,141.18l.21,3.15v-.84l.21,1.89.21.21.21,2.52.21.21.21,1.47v-.22l.21.84.21,1.06.21,1.05.21,1,.21.84.21.64.42.2.21.42.63.21h.21v.21H163l.21.85h.21v.2l.21.22.63.2.84.22H167l1.68-.22.42-.2.42-.22.63-.2.42-.22.42-.21.21-.21.42-.42.21-.21.42-.42V155l.42-.42v-.22l.21-.42.21-.62.21-.84v-1.27l-.21-.84-.21-.62-.21-.42-.21-.42-.42-.42-.42-.42-.42-.21-.21-.22-.42-.2-.21-.22-.42-.2-.21-.21-.63-.21-.42-.21.21-.21.21-.42.21-.42.21-.42.21-.63.21-.84v-1.05l-.21-.84-.21-.42-.21-.42-.21-.42-.21-.42-.42-.42-.42-.42-.42-.21-.42-.21-.63-.21-.63-.21-.84-.21-.84-.21h-1.05l-1.26.21-.84.21-.42.21-.42.21-.42.21-.42.42-.21.21-.42.42-.21.21-.21.21-.21.84Zm5.25,4.2h-.84l-.42-2.1v-.42l.21-.84h.21l.42-.21h0l2.1.21h-.63l1.26.21.21.42v.63l-.21.63-.21.21-.42.42h-.21l-.42.42-.42.21-.63.21Zm3.15,4.61.84.22.63.2.42.22.21.42.63.2.21.84h0l-.42.63-.21.22-.42.42-.42.2-.84.22h-2.73l-.21-.64-.21-.84-.21-.83-.21-1.06V150h2.94Z"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    points: "190.26 147.9 190.47 149.79 190.47 149.79 190.68 150.83 190.89 151.26 191.1 151.68 191.31 152.31 191.52 152.72 191.73 153.14 191.94 153.56 192.36 153.78 192.57 154.4 192.99 154.62 193.2 155.03 193.62 155.24 193.83 155.67 194.25 155.88 194.67 156.09 194.88 156.51 195.51 156.71 195.93 156.93 196.35 157.13 196.98 157.35 198.03 157.55 199.08 157.76 202.44 157.76 203.28 157.55 204.12 157.35 205.17 157.13 205.59 156.93 206.01 156.71 206.43 156.51 206.64 156.09 206.85 155.67 206.85 154.82 206.64 154.2 206.43 153.78 206.01 153.56 205.38 153.36 205.38 153.36 204.75 153.14 204.33 153.36 203.28 153.56 202.44 153.78 198.87 153.78 198.03 153.56 197.4 153.36 196.98 153.14 196.77 152.72 196.35 152.52 196.14 152.1 195.72 151.89 195.51 151.47 195.09 151.26 194.88 150.83 194.67 150.21 194.46 149.79 194.25 148.53 194.25 147.9 194.46 147.27 194.67 146.84 195.09 146.43 195.3 146.22 195.72 145.8 195.93 145.59 196.56 145.17 196.77 144.96 197.61 144.54 198.87 144.54 199.29 144.75 200.13 144.96 200.76 145.17 201.39 145.17 202.02 144.96 202.44 144.75 202.65 144.33 202.86 143.7 202.86 142.86 202.65 142.23 202.44 141.81 202.02 141.6 201.6 141.18 200.76 140.97 199.92 140.76 199.08 140.55 197.4 140.55 196.56 140.76 196.14 140.97 195.51 141.18 195.09 141.6 194.67 141.81 194.25 142.02 193.83 142.44 193.41 142.65 192.99 143.07 192.78 143.28 192.36 143.7 192.15 143.91 191.73 144.33 191.52 144.54 191.31 144.96 191.1 145.17 190.89 145.8 190.68 146.43 190.47 147.06 190.26 147.9 190.26 147.9"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M223.57,141l.21,2.52h0l.21.63h0l.21,1.26h0l.21,3.15.21.21.21,4v-1l.21,2.1.21.2v1.27l.21,1,.21.42.21.42.42.22.42.2.42.22h1.05l.42-.22.42-.2,1.05-.22.84-.2.84-.22.84-.2.42-.22.42-.2.21-.21.84-.42.42-.21.21-.21.42-.21.21-.21.41-.42.22-.42.21-.42.21-.42.21-.42.21-.63.21-1v-2.73l-.21-.84-.21-.63-.21-.42-.21-.42-.21-.42-.22-.42-.2-.42-.42-.42-.21-.42-.42-.21-.21-.42-.42-.21-.21-.42-.42-.21-.42-.21-.42-.42-.42-.21-.21-.42-.42-.21-.21-.21-.42-.21-.42-.21-.42-.21-.63-.21-.63-.21-.84-.21h-2.73l-.42.21-.63.21h0l-.21.21h0l-.21.21h0l-.21.21h0v.21l-.21.42Zm4.62,2.31.63.21.42.21.42.21.21.42.42.21.42.21.21.42.63.21.21.42.42.21.21.42.42.21.21.63.21.42.21.42v2.73l-.21.63-.21.21-.42.42-.42.21-.42.21-.42.42h-.42l-.84.2H229l-.21-.41-.21-1L228.4,149l-.21-1.47-.21-2.73-.21-1.05v-.42h.42Z"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    points: "257.59 143.7 257.8 147.69 257.8 146.43 258.01 150.21 258.01 150.21 258.22 150.84 258.22 150.84 258.43 155.25 258.43 153.99 258.64 155.88 258.64 155.46 258.85 156.3 259.27 156.51 259.27 156.93 259.9 157.14 260.11 157.56 262 157.77 268.72 157.77 269.56 157.77 269.98 157.77 270.61 157.35 271.03 157.14 271.24 156.72 271.45 156.09 271.45 155.46 271.24 154.83 271.03 154.41 270.61 154.2 270.4 153.99 269.35 153.78 268.93 153.99 266.83 153.78 266.83 153.78 262.21 153.36 262.42 151.05 262.42 151.26 263.05 151.05 263.26 151.05 266.62 151.26 266.83 151.47 269.56 151.05 269.14 151.26 269.98 150.84 270.19 150.42 270.4 149.79 270.4 149.16 270.19 148.53 269.98 148.11 269.56 147.9 269.35 147.69 266.83 147.48 266.83 147.48 264.94 147.27 264.94 147.27 263.68 147.06 263.68 147.06 262 146.85 261.79 146.85 261.79 146.85 261.58 144.96 261.58 146.22 261.58 145.8 261.79 144.96 263.68 144.54 263.89 144.54 266.41 144.12 266.62 144.12 267.88 143.7 268.3 143.49 268.72 143.28 268.93 142.86 269.14 142.23 269.14 141.6 268.93 140.97 268.72 140.55 268.3 140.34 268.09 140.13 267.04 139.92 266.62 140.13 265.15 140.34 263.89 140.55 262.84 140.76 261.58 140.97 260.74 141.18 259.9 141.39 259.06 141.6 258.64 142.02 258.43 142.23 258.01 142.65 257.8 142.86 257.59 143.7 257.59 143.7"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    points: "304.62 149.24 304.75 150 304.88 150.26 305.26 150.39 305.64 150.51 306.15 150.51 306.91 150.51 306.91 152.04 307.04 153.44 307.17 155.35 307.3 156.62 307.42 157 307.55 157.26 307.68 157.51 308.06 157.64 308.31 157.76 308.95 157.76 309.2 157.64 309.46 157.51 309.58 157.26 309.71 156.87 309.71 156.24 309.58 155.35 309.46 153.57 309.33 152.29 309.2 150.77 309.2 150.39 311.62 150.26 312 150.13 312.38 150 312.64 149.88 312.64 149.75 312.89 149.5 312.89 149.24 312.89 148.99 312.77 148.48 312.64 148.22 312.38 148.1 312.26 147.97 311.49 147.84 311.24 147.97 309.2 147.72 309.33 147.2 309.46 146.95 309.58 146.57 309.84 146.31 309.97 146.06 310.86 145.93 311.75 145.93 312.13 145.93 312.51 145.81 312.77 145.68 312.77 145.55 313.02 145.3 313.02 145.04 313.02 144.79 312.89 144.28 312.77 144.02 312.51 143.9 312.38 143.64 311.88 143.51 310.1 143.51 309.58 143.64 309.33 143.77 309.08 143.9 308.82 144.02 308.57 144.15 308.31 144.41 308.19 144.53 307.93 144.79 307.8 145.04 307.68 145.17 307.55 145.42 307.42 145.68 307.3 146.06 307.17 146.31 307.04 146.7 306.91 147.08 306.79 147.59 306.66 148.1 306.02 148.1 305.51 148.22 305.26 148.35 305.01 148.6 304.88 148.73 304.75 148.86 304.62 149.24",
    opacity: 0.6
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    points: "289.89 142.23 290.11 143.7 290.31 144.33 290.53 145.59 290.74 146.64 290.95 148.95 291.15 151.05 291.37 152.94 291.57 154.62 291.79 156.09 291.99 156.72 292.41 156.93 292.63 157.56 293.67 157.76 294.31 157.76 294.94 157.56 295.36 157.34 295.56 156.93 295.78 156.3 295.78 155.67 295.56 154.62 295.36 152.94 295.36 151.68 297.45 151.47 299.35 151.26 301.02 151.05 301.65 150.84 302.07 150.63 302.28 150.21 302.49 149.58 302.49 148.95 302.28 148.32 302.07 147.9 301.65 147.69 301.44 147.48 299.35 147.27 300.39 147.27 297.45 147.48 297.04 147.69 294.94 147.27 294.94 147.48 294.94 147.06 294.52 145.59 294.31 144.33 294.31 144.12 300.6 144.12 300.6 144.12 300.81 144.12 301.65 143.7 301.86 143.28 302.07 142.65 302.07 142.02 301.86 141.39 301.65 140.97 301.23 140.76 301.02 140.55 299.13 140.13 298.71 140.13 291.79 140.34 293.25 140.34 290.95 140.55 291.37 140.55 290.74 140.76 290.74 140.76 290.53 140.97 290.53 140.97 290.31 141.18 290.31 141.18 290.11 141.39 290.11 141.39 290.11 141.6 289.89 142.23"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M338.86,149l.14,1.73v-.58l.14.86v-.14l.15.43.14.29.14.28.29.15v.28l.29.15.14.28.43.15.14.29.58.14.28.14.29.14h1.72l.58-.14.57-.14.29-.14h.14l-.28.57-.15.29-.14.14-.29.29-.14.14-.29.29-.86.14-.29.14-3.3.15h.29l-.43.14h0l-.14.14h0l-.15.15h0l-.14.14h0V156l-.14.72.14.14.14.44.15.28h.28l.43.15h3.16l.57-.15.43-.14.58-.14.43-.15.29-.14.28-.15.15-.14.43-.28.14-.15.29-.29.14-.14.29-.29v-.14l.14-.29.14-.28.15-.29.14-.29.15-.43.14-.57.14-.86v-4.74h0v-.28l-.28-.29-.15-.29-.14-.29-.29-.14-.14-.14-.29-.15-.29-.14-.43-.14-.43-.15-.43-.14-.72-.14h-2l-.58.14-.29.14-.43.15-.43.14-.28.29-.29.14-.29.29-.14.14-.29.43-.14.15-.29.57-.14.43-.14.57Zm4.87,1.87h-1.29l-.28-.14-.15-.29-.29-.15-.14-.28v-1l.29-.28.14-.15.43-.28.29-.15h2l.43.15.14.14-.28.72-.15.28-.14.29-.15.29-.14.14-.29.29-.14.14-.29.29Z",
    opacity: 0.6
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    points: "322.39 147.48 322.61 151.68 322.61 150.84 322.81 152.31 323.03 152.52 323.23 153.78 323.44 153.99 323.65 154.83 323.87 155.25 324.29 155.46 324.49 155.88 324.91 156.09 324.91 156.51 325.54 156.72 325.75 157.14 326.59 157.34 327.01 157.56 327.44 157.76 327.86 157.98 328.27 158.19 329.74 158.19 330.16 157.98 330.58 157.76 331 157.56 331.43 157.34 331.85 157.14 332.26 156.93 332.47 156.72 333.1 156.3 333.31 156.09 333.73 155.67 333.94 155.46 334.36 155.03 334.57 154.83 334.99 154.41 334.99 154.19 335.2 153.78 335.62 153.36 335.62 153.15 335.83 152.73 336.25 152.31 336.25 152.1 336.46 151.68 336.67 151.26 336.88 150 336.88 148.74 336.67 148.11 336.46 147.69 336.04 147.48 335.83 147.27 334.78 147.06 334.36 147.27 333.52 147.48 333.1 147.69 327.64 147.9 328.06 147.9 327.44 148.11 327.44 148.11 327.22 148.32 327.22 148.32 327.01 148.53 327.01 148.53 326.8 148.74 326.8 148.74 326.8 148.95 326.59 150 326.8 150.21 327.01 150.84 327.22 151.26 327.64 151.26 328.27 151.47 331.85 151.68 331.63 152.1 331.43 152.31 331 152.73 330.79 152.94 330.37 153.36 330.16 153.57 329.74 153.99 329.11 154.19 328.9 154.19 328.48 153.99 328.06 153.78 327.64 153.57 327.44 153.15 327.22 152.73 326.8 152.1 326.8 151.68 326.38 150.63 326.38 150.21 326.59 147.06 326.59 147.27 326.8 146.85 327.22 146.43 327.64 146.22 327.86 146.01 328.48 145.59 329.11 145.38 330.37 145.17 330.58 145.17 330.79 145.38 332.05 144.96 332.47 144.75 332.68 144.33 332.89 143.7 332.89 143.07 332.68 142.44 332.47 142.02 332.05 141.81 331.63 141.39 330.79 141.18 330.16 141.18 329.32 141.39 328.06 141.6 327.64 141.81 327.01 142.02 326.38 142.23 325.96 142.44 325.54 142.86 325.13 143.07 324.7 143.49 324.49 143.7 324.07 143.91 323.65 144.54 323.44 144.75 323.03 145.38 323.03 145.59 322.61 146.85 322.39 147.48 322.39 147.48"
  })), _polygon0 || (_polygon0 = /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    points: "375.56 144.91 375.45 146.2 375.45 146.93 375.49 147.52 375.54 147.97 375.6 148.42 375.58 149.3 375.53 150.31 375.56 150.9 375.59 151.49 375.54 152.5 375.6 152.95 375.52 154.11 375.33 155.82 375.33 156.56 375.37 157.15 375.42 157.6 375.51 157.91 375.57 158.36 375.65 158.66 376.05 158.89 376.44 159.11 376.87 159.19 377.32 159.14 377.63 159.05 377.82 158.79 378.04 158.4 378.18 157.69 378.2 156.82 378.2 156.09 378.23 155.22 378.25 154.35 378.33 153.92 378.61 153.25 378.89 152.57 379.08 152.32 379.42 152.09 379.59 151.97 379.92 151.75 380.09 151.64 380.4 151.55 380.68 151.6 380.77 151.91 380.86 152.22 381.11 152.42 381.05 152.7 381.14 153.01 381.23 153.32 381.31 153.63 381.37 154.08 381.46 154.39 381.54 154.69 381.57 155.29 381.6 155.88 381.64 156.47 381.69 156.92 381.64 157.93 381.7 158.38 381.76 158.83 381.85 159.14 382.24 159.36 382.64 159.59 383.06 159.67 383.51 159.61 383.82 159.53 384.01 159.27 384.24 158.88 384.35 158.31 384.4 157.3 384.34 156.85 384.31 156.26 384.28 155.66 384.25 155.07 384.22 154.49 384.13 154.18 384.04 153.87 384.01 153.28 383.93 152.97 383.84 152.66 383.64 152.18 383.56 151.87 383.5 151.42 383.41 151.11 383.15 150.91 383.07 150.61 382.98 150.3 382.73 150.1 382.64 149.79 382.39 149.6 382.16 149.26 381.63 149.01 380.78 148.84 380.33 148.9 379.88 148.96 379.43 149.02 379.1 149.25 378.79 149.34 378.45 149.56 378.31 149.53 378.25 148.35 378.3 148.07 378.16 147.31 378.21 147.03 378.15 145.85 378.09 145.4 378.03 144.95 377.94 144.64 377.69 144.44 377.58 144.28 376.28 144.17 376.28 144.17 376.12 144.28 375.78 144.51 375.56 144.91 375.56 144.91",
    opacity: 0.6
  })), _polygon1 || (_polygon1 = /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    points: "357.77 144.12 357.98 146.22 358.19 147.06 358.4 149.16 358.61 150.42 358.82 153.99 359.03 157.34 359.24 157.98 359.45 158.4 360.08 158.6 360.71 158.82 361.34 158.82 361.97 158.6 362.39 158.4 362.39 158.19 362.81 157.76 362.81 157.34 362.81 154.19 362.81 150.63 367.85 150.63 368.06 153.78 368.06 153.78 368.27 157.76 368.48 158.4 368.69 158.82 369.32 159.03 369.95 159.24 370.58 159.24 371.21 159.03 371.63 158.82 371.63 158.6 372.05 158.19 372.05 157.76 372.05 155.67 371.84 152.1 371.63 146.64 371.42 144.33 371.21 143.49 371 142.23 370.79 141.39 370.58 140.97 370.16 140.76 369.95 140.55 368.06 140.76 368.06 140.76 367.85 140.97 367.85 140.97 367.64 141.18 367.64 141.18 367.43 141.39 367.43 141.39 367.43 141.6 367.22 142.86 367.22 142.86 367.43 144.33 367.64 146.22 367.64 146.64 362.18 146.64 362.18 146.64 361.97 144.75 361.76 144.54 361.55 143.91 361.34 143.49 361.13 143.07 360.71 142.86 360.5 142.65 358.61 142.86 358.61 142.86 358.4 143.07 358.4 143.07 358.19 143.28 358.19 143.28 357.98 143.49 357.98 143.49 357.98 143.7 357.77 144.12"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M303.45,251.36l-8-13.56a26.76,26.76,0,0,0-1.54-2.38,2.66,2.66,0,0,0-1.6-1,4.11,4.11,0,0,0-4,1.87,5.79,5.79,0,0,0-.55,1.23,2.77,2.77,0,0,0,.15,1.92A24.36,24.36,0,0,0,289.2,242l7.93,13.37c.36.61.67,1.13.93,1.54a9.61,9.61,0,0,0,.75,1,2.59,2.59,0,0,0,.74.59,2.52,2.52,0,0,0,.88.25,4.22,4.22,0,0,0,1,0,3.18,3.18,0,0,0,.93-.27,9.85,9.85,0,0,0,1.17-.65l1.73-1.13,9.17-6.13c.9-.61,1.6-1.11,2.09-1.51a2.89,2.89,0,0,0,.71-3.68,2,2,0,0,0-.88-.85,3.79,3.79,0,0,0-.95-.32,2.43,2.43,0,0,0-1.57.32,24.52,24.52,0,0,0-2.18,1.35Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReading);
export default __webpack_public_path__ + "static/media/reading.6eff7bad8bb259542d63fa5a8c8b07c8.svg";
export { ForwardRef as ReactComponent };